/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { HOTJAR_SITE_ID } from './usercentricsConfig';

let hotjarInitialized = false;

export const isHotjarInitialized = (): boolean => hotjarInitialized;

export const initHotjar = (): void => {
  if (hotjarInitialized || typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  type HotjarWindow = Window & {
    hj?: ((...args: unknown[]) => void) & { q?: unknown[] };
    _hjSettings?: { hjid: number; hjsv: number };
  };

  const windowWithHotjar = window as HotjarWindow;

  windowWithHotjar.hj =
    windowWithHotjar.hj ||
    function hotjarQueue(...args: unknown[]) {
      windowWithHotjar.hj!.q = windowWithHotjar.hj!.q || [];
      windowWithHotjar.hj!.q.push(args);
    };

  // Hotjar's loader reads window._hjSettings before the script runs.
  // eslint-disable-next-line no-underscore-dangle
  windowWithHotjar._hjSettings = { hjid: HOTJAR_SITE_ID, hjsv: 6 };

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://static.hotjar.com/c/hotjar-${HOTJAR_SITE_ID}.js?sv=6`;

  document.head.appendChild(script);
  hotjarInitialized = true;
};

export const teardownHotjar = (): void => {
  if (!hotjarInitialized || typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  document
    .querySelectorAll(`script[src*="hotjar-${HOTJAR_SITE_ID}"]`)
    .forEach((script) => script.remove());

  type HotjarWindow = Window & {
    hj?: unknown;
    _hjSettings?: unknown;
  };

  const windowWithHotjar = window as HotjarWindow;
  delete windowWithHotjar.hj;
  // eslint-disable-next-line no-underscore-dangle
  delete windowWithHotjar._hjSettings;

  hotjarInitialized = false;
};
